import { z } from "zod"

export const viewerSchema = z.object({
    id: z.string(),
    name: z.string(),
    userId: z.string(),
    projectId: z.string(),
    email: z.string(),
})

export type Viewer = z.infer<typeof viewerSchema>
